/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography, {TypographyProps} from '@material-ui/core/Typography';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {HeaderTypographyVariantEnum} from '@/types/';

export interface HeaderTypographyProps extends TypographyProps {
  children: string;
  variant?: keyof typeof HeaderTypographyVariantEnum;
}

const useStyles = makeStyles(theme => ({
  root : {
    color : dlsColor('grey1')
  }
}));

/**
 *
 * @HeaderTypography
 *
 * DLS Foundational Design Typography Header text:
 * https://www.figma.com/file/gtF4hB3eC4fvzKVJ2DNDtu/01_DLS_Foundation?node-id=1244%3A34
 *
 * ```typescript
 *
 * import React from 'react';
 * import { HeaderTypography } from '@ion/dls/src/typography';
 *
 * function MyComponent {
 *   return (
 *     <React.Fragment>
 *       <HeaderTypography>Default Header 3</HeaderTypography>
 *       <br />
 *       <HeaderTypography variant='h1'>Header 1</HeaderTypography>
 *       <br />
 *       <HeaderTypography variant='h2'>Header 2</HeaderTypography>
 *       <br />
 *       <HeaderTypography variant='h4'>Header 4</HeaderTypography>
 *     </React.Fragment>
 *   );
 * }
 *
 * ```
 *
 */
const HeaderTypography = ({
  children,
  variant = 'h3',
  ...props
}: HeaderTypographyProps) => {
  const classes = useStyles();
  return (
    <Typography variant={variant}
      className={classes.root}
      {...props}>
      {children}
    </Typography>
  );
};
export {HeaderTypography};
